export default class FarloUiMastheadCarousel {
	constructor(element) {
		this.flktyPost = new Flickity(element, {
			cellAlign: 'center',
			pageDots: false,
			prevNextButtons: false,
			wrapAround: true,
			groupCells: false,
			freeScroll: false,
			draggable: true,
			dragThreshold: 1,
			autoPlay: 6000,
		});
	}
}
